/* eslint-disable no-restricted-imports -- legacy_modulesを削除できるまで無効化 */
import { useNavigate } from 'react-router'
import { selectTrialHospitalAndReload } from 'src/features/auth/api/selectTrialHospital/selectTrialHospitalAndReload'
import { useSelectedTrial } from 'src/features/auth/context'
import { routes } from 'src/legacy_modules/routes'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

export const useSelectHospital = () => {
  const { selectedTrial } = useSelectedTrial()

  const toast = useMirohaToast()

  const navigate = useNavigate()

  const handleSelectHospital = (hospitalUid: string) => {
    selectTrialHospitalAndReload({
      trialUid: selectedTrial.uid,
      trialHospitalUid: hospitalUid,
    }).catch(error => {
      toast({
        status: 'error',
        title: '医療機関選択中にエラーが発生しました。',
      })
      if (error.original?.response?.status === 403) {
        navigate(routes.httpError403)
      }
    })
    navigate('/switch')
  }

  return {
    handleSelectHospital,
  }
}
